import { Input, Radio } from "antd";
import React, { useState, useEffect } from "react";
import { FaTrash } from "react-icons/fa6";
import { Input as AntdInput } from "antd";
import trans from "../../../../utils";

export default function FormOptionDropdown({
	placeholder,
	dropdownOptions,
	id,
	onChange,
	queryKey,
	addForm,
	localErrors,
	setLocalErrors,
}) {
	const defaultStaticOptions = [
		{ label: `${trans("Option")} 1`, value: "Option 1" },
		{ label: `${trans("Option")} 2`, value: "Option 2" },
		{ label: `${trans("Option")} 3`, value: "Option 3" },
	];

	const [savedStaticOptions, setSavedStaticOptions] = useState([]);
	const [options, setOptions] = useState([]);
	const [dbKey, setDbKey] = useState("");
	// Sync props on mount or id change
	useEffect(() => {
		if (queryKey === "static") {
			const fallback =
				savedStaticOptions.length > 0
					? savedStaticOptions
					: dropdownOptions?.length > 0
					? dropdownOptions
					: defaultStaticOptions;
			setOptions(fallback);
		} else {
			setDbKey(dropdownOptions?.queryKey || "");
		}
	}, [id, queryKey]);

	// Report value up
	useEffect(() => {
		if (!onChange) return;
		if (queryKey === "static") {
			onChange({
				target: {
					value: {
						queryKey: "static",
						data: options,
					},
				},
			});
		} else {
			onChange({
				target: {
					value: {
						queryKey: dbKey,
						data: null,
					},
				},
			});
		}
	}, [options, dbKey, queryKey]);
	useEffect(() => {
		if (queryKey === "static") {
			const newErrors = {};

			// build fresh errors
			options.forEach((opt, i) => {
				if (!opt.label || opt.label.trim() === "") {
					newErrors[`${id}_${i}`] = trans("This field is required");
				}
			});

			// ✅ merge + cleanup old dropdown errors
			setLocalErrors((prev) => {
				const updated = { ...prev, ...newErrors };

				// remove old dropdown_* errors not in newErrors anymore
				Object.keys(updated).forEach((key) => {
					if (key.startsWith(`${id}_`) && !(key in newErrors)) {
						delete updated[key];
					}
				});

				return updated;
			});
		}
	}, [options, queryKey, trans, setLocalErrors]);

	console.log("localErrors", localErrors);
	// Handlers
	const handleLabelOptionChange = (index, newValue) => {
		setOptions((prev) =>
			prev.map((option, i) =>
				i === index ? { ...option, label: newValue, value: newValue } : option
			)
		);
	};

	const addOption = () => {
		setOptions((prev) => [
			...prev,
			{ label: `${trans("Option")} ${prev.length + 1}`, value: "" },
		]);
	};

	return (
		<>
			<Radio.Group
				style={{ display: "flex", flexDirection: "row", gap: 8 }}
				onChange={(e) => {
					if (queryKey === "static") {
						setSavedStaticOptions(options); // save before switching
					}
					onChange({
						target: {
							value: {
								queryKey: e.target.value,
							},
						},
					});
				}}
				value={queryKey === "static" ? "static" : "dbkey"}
				options={[
					{ value: "static", label: trans("Custom data") },
					{ value: "dbkey", label: trans("Database") },
				]}
			/>
			{queryKey === "static" ? (
				<div className="position-relative mt-2">
					<div className="task-radio-layout" key={id}>
						{options.map((option, index) => (
							<div key={index}>
								<div className="task-option-item mb-2 d-flex">
									<label htmlFor={`option-${index}`} className="form-label">
										{`${trans("Option")} ${index + 1}`}
									</label>
									<FaTrash
										color="red"
										className="task-option-bin"
										onClick={() => {
											const newOptions = [...options];
											newOptions.splice(index, 1);
											if (newOptions.length === 0) {
												newOptions.push(
													{ value: "Option 1", label: `${trans("Option")} 1` },
													{ value: "Option 2", label: `${trans("Option")} 2` },
													{ value: "Option 3", label: `${trans("Option")} 3` }
												);
											}
											setOptions(newOptions);
										}}
									/>
								</div>
								<div className="ms-3 mb-2">
									<div className="flex-between mb-2">
										<label className="form-label">{trans("Label")}</label>
										<Input
											placeholder={placeholder}
											value={option.label}
											onChange={(e) =>
												handleLabelOptionChange(index, e.target.value)
											}
										/>
										{localErrors[`${id}_${index}`] && (
											<div
												className="text-danger"
												style={{ marginTop: 4, fontSize: 12 }}
											>
												{localErrors[`${id}_${index}`]}
											</div>
										)}
									</div>
								</div>
							</div>
						))}
					</div>
					<div
						onClick={addOption}
						className="cursor-pointer text-blue-500 hover:text-blue-700 task-radio-add-btn"
					>
						{trans("Add")}
					</div>
				</div>
			) : (
				<>
					<label
						htmlFor={id}
						className="form-label d-flex align-items-center mt-2"
					>
						{trans("Database key")}
					</label>
					<AntdInput
						type="text"
						value={dbKey}
						placeholder={trans("Enter Query key")}
						onChange={(e) => setDbKey(e.target.value)}
					/>
				</>
			)}
		</>
	);
}
